/** @jsxImportSource theme-ui */
import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeUIStyleObject } from 'theme-ui';

import theme from 'theme';

import { Loading } from 'components/Loading';

import * as UserSelectors from 'user/user.selectors';

const Styles: ThemeUIStyleObject = {
  position: 'absolute',
  bg: theme.colors.stone10,
  opacity: 0.75,
  width: '100%',
  height: '100%',
  zIndex: 1000,
};

const SettingsLoader: React.FC = () => {
  const isLoadingSettings = useSelector(UserSelectors.isSettingsLoadingSelector);

  return isLoadingSettings ? (
    <>
      <div sx={Styles} />
      <Loading />
    </>
  ) : null;
};

export default SettingsLoader;
